var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.66309 9.5332V11.5332H4.66309V9.5332H6.66309ZM10.6631 9.5332V11.5332H8.66309V9.5332H10.6631ZM14.6631 9.5332V11.5332H12.6631V9.5332H14.6631ZM16.6631 2.5332C17.1935 2.5332 17.7022 2.74392 18.0773 3.11899C18.4524 3.49406 18.6631 4.00277 18.6631 4.5332V18.5332C18.6631 19.0636 18.4524 19.5723 18.0773 19.9474C17.7022 20.3225 17.1935 20.5332 16.6631 20.5332H2.66309C1.55309 20.5332 0.663086 19.6332 0.663086 18.5332V4.5332C0.663086 4.00277 0.8738 3.49406 1.24887 3.11899C1.62394 2.74392 2.13265 2.5332 2.66309 2.5332H3.66309V0.533203H5.66309V2.5332H13.6631V0.533203H15.6631V2.5332H16.6631ZM16.6631 18.5332V7.5332H2.66309V18.5332H16.6631ZM6.66309 13.5332V15.5332H4.66309V13.5332H6.66309ZM10.6631 13.5332V15.5332H8.66309V13.5332H10.6631ZM14.6631 13.5332V15.5332H12.6631V13.5332H14.6631Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCalendar);
export default __webpack_public_path__ + "static/media/white_calendar.1d63aab3f3a191c9c633af624306efd5.svg";
export { ForwardRef as ReactComponent };